'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { EPL_FAQ_CATEGORIES } from '@constants/epl'

export default function EPLFaq() {
  const [activeTab, setActiveTab] = useState('shipping')
  const [openId, setOpenId] = useState<string | null>(null)

  const activeCategory = EPL_FAQ_CATEGORIES.find((c) => c.id === activeTab)

  function handleTabChange(id: string) {
    setActiveTab(id)
    setOpenId(null)
  }

  return (
    <section className="max-w-screen-2xl mx-auto px-4 mt-10 mb-10" aria-labelledby="epl-faq-heading">
      {/* Heading — matches .hp-faq-title */}
      <h2
        id="epl-faq-heading"
        className="text-center"
        style={{
          fontSize: 'clamp(20px, 3vw, 36px)',
          fontWeight: 900,
          color: 'rgb(21,34,68)',
          marginBottom: 24,
        }}
      >
        Frequently asked questions
      </h2>

      {/* Tab bar — matches .hp-faq-tabs */}
      <div className="flex justify-center mb-6">
        <div className="flex gap-2 flex-wrap justify-center">
          {EPL_FAQ_CATEGORIES.map((cat) => {
            const isActive = activeTab === cat.id
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => handleTabChange(cat.id)}
                aria-pressed={isActive}
                style={{
                  padding: '8px 20px',
                  borderRadius: 20,
                  fontSize: 14,
                  fontWeight: 500,
                  border: '1px solid',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  backgroundColor: isActive ? 'rgb(20,52,105)' : 'transparent',
                  color: isActive ? 'white' : 'rgb(20,52,105)',
                  borderColor: 'rgb(20,52,105)',
                }}
              >
                {cat.label}
              </button>
            )
          })}
        </div>
      </div>

      {/* Accordion items */}
      <div className="max-w-3xl mx-auto">
        {activeCategory?.items.map((item) => {
          const isOpen = openId === item.id
          return (
            <div
              key={item.id}
              style={{
                borderBottom: '1px solid rgb(229,231,235)',
              }}
            >
              <button
                type="button"
                onClick={() => setOpenId(isOpen ? null : item.id)}
                className="w-full flex items-center justify-between text-left"
                style={{
                  padding: '16px 0',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                }}
                aria-expanded={isOpen}
              >
                <h3 style={{ fontSize: 16, fontWeight: 600, color: 'rgb(33,33,33)', margin: 0 }}>
                  {item.question}
                </h3>
                <ChevronDown
                  className={`flex-shrink-0 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                  style={{ width: 20, height: 20, marginLeft: 12 }}
                  aria-hidden
                />
              </button>

              {isOpen && (
                <div style={{ paddingBottom: 16, paddingRight: 32 }}>
                  <p style={{ fontSize: 14, color: 'rgb(80,80,80)', lineHeight: 1.6, margin: 0 }}>
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </section>
  )
}
